export const SOCKET_EVENTS = {
    CHANGE_POSITION: "CHANGE_POSITION",
    DRIVER_ALERT: "DRIVER_ALERT",
    UPDATE_COUNTER: "UPDATE_COUNTER",
    FLAG_CONFIRMED: "FLAG_CONFIRMED",
}